// Module-level beta agreement gate for llmProxy.
// The BetaAgreementGateProvider registers a gate function that shows
// a modal when the user hasn't accepted the beta agreement yet.

type GateFn = () => Promise<void>;

let gateResolver: GateFn | null = null;
let pendingGate: Promise<void> | null = null;

export function registerBetaGate(fn: GateFn): void {
  gateResolver = fn;
}

export function unregisterBetaGate(): void {
  gateResolver = null;
  pendingGate = null;
}

/**
 * Check the beta gate before making an LLM call.
 * If the user hasn't accepted the beta agreement, this shows a modal
 * and waits for acceptance. Multiple concurrent calls share one modal.
 */
export async function checkBetaGate(): Promise<void> {
  if (!gateResolver) return;
  if (pendingGate) return pendingGate;
  pendingGate = gateResolver();
  try {
    await pendingGate;
  } finally {
    pendingGate = null;
  }
}
